import React, { CSSProperties, HTMLAttributes } from "react";
import VisualDiff from "react-visual-diff";

import {
  renderRichContentForDisplay,
  RichContentDisplayOptions,
} from "@examspark/common-ui";

import UnitContent from "./UnitContent";

const addedStyles: CSSProperties = {
  filter: "brightness(75%)",
  fontWeight: "bold",
  textDecoration: "undefline",
};

const removedStyles: CSSProperties = {
  filter: "brightness(125%)",
  textDecoration: "line-through",
};

type SpecificityComparisonProps = {
  original: string | null | undefined;
  customized: string | null | undefined;
  options?: RichContentDisplayOptions;
};

const SpecificityComparison = ({
  original,
  customized,
  options,
}: SpecificityComparisonProps) => {
  if (original == null || customized == null) return null;

  const originalRendered = renderRichContentForDisplay(original, options);
  const customizedRendered = renderRichContentForDisplay(customized, options);

  return (
    <UnitContent.Wrapper>
      <VisualDiff
        left={<div>{originalRendered}</div>}
        right={<div>{customizedRendered}</div>}
        renderChange={({ type, children }) =>
          React.Children.map(children, (child) => {
            const style = type === "added" ? addedStyles : removedStyles;
            if (!React.isValidElement<HTMLAttributes<HTMLElement>>(child)) {
              return <span style={style}>{child}</span>;
            }

            return React.cloneElement(child, { style });
          })
        }
      />
    </UnitContent.Wrapper>
  );
};

export default SpecificityComparison;
